import React from 'react';
import {useLocation} from 'wouter';

import {useGetNodeContentQuery} from './use-get-node-content-structure';
import {GraphResultPanelView} from '../../../../../../components/graph/components/factset-panel/graph-results-panel/graph-result-panel-view';

interface Props {
    queryInfo: QueryInfo;
    selectedNodes: number[];
    clearNodeSelection: () => void;
    isPanelCollapsed: boolean;
    toggleIsPanelCollapsed: () => void;
    maxPathLength: number;
    canFetchNodeStructure: boolean;
}

export const collapsedFactsetPanelHeight = 54;

export function QueryGraphFactsetPanel(props: Props) {
    const [, navigate] = useLocation();
    const nodeContentQuery = useGetNodeContentQuery(
        props.queryInfo.id,
        props.maxPathLength,
        props.selectedNodes,
        props.canFetchNodeStructure
    );

    const closePanel = () => {
        props.clearNodeSelection();
        navigate(`/${props.queryInfo.id}`);
    };

    return (
        <GraphResultPanelView
            selectedNodes={props.selectedNodes}
            isPanelCollapsed={props.isPanelCollapsed}
            toggleIsPanelCollapsed={props.toggleIsPanelCollapsed}
            contentRequest={nodeContentQuery}
            closePanel={closePanel}
            globalVersionId={props.queryInfo.globalVersionId}
        />
    );
}
